<template>
  <jt-card-default
    :shouldShowSelectMonth="true"
    :cardSelectType="0"
    @change="onChangeSelectBar"
  >
    <div v-if="isLoadingBar" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-bar-chart
      v-else
      centralTitleConst="DASHBOARD_BILLING_INDUSTRIAL_TOP_TEN"
      class="editCss"
      :data="collectionsSpecialComunData"
      :xAxisData="collectionsSpecialComunColumn"
      :shouldShowOverlappingBars="true"
      :horizontalBar="true"
    />
  </jt-card-default>
</template>

<script>
import JtBarChart from 'src/components/charts/JtBarChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'IndustrialTopTen',
  components: {
    JtCardDefault,
    JtBarChart
  }
})
export default class IndustrialTopTen extends Vue {
  isLoadingBar = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  doughnutData = [];
  collectionsSpecialComunColumn = [];
  collectionsSpecialComunData = [];

  async onChangeSelectBar (newValue) {
    this.isLoadingBar = true

    this.doughnutData = await this.getDoughnutData(newValue)

    this.doughnutData.sort((a, b) => a.value - b.value)

    this.collectionsSpecialComunData = [
      {
        data: this.doughnutData.map((register) => register.value),
        name: this.$gettext('DASHBOARD_BILLING_INDUSTRIAL_TOP_TEN_RS_FATURAR')
      }
    ]

    this.collectionsSpecialComunColumn = this.doughnutData.map(
      (register) => register.label
    )

    setTimeout(() => {
      this.isLoadingBar = false
    }, 500)
  }

  async created () {
    await this.onChangeSelectBar(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'industrialTopTen',
        month: date.month,
        year: date.year
      }
    )

    const data = registros.map((registro) => {
      return {
        label: registro.name,
        value: Number(registro.value.replaceAll('.', '').replace(',', '.'))
      }
    })

    return data
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
